<template>
  <div style="margin-bottom: 40px">
    <label v-if="checkUrl()" style="font-weight: bold;" class="typo__label" for="ajax">{{$t("message.selectWork")}}</label>
    <label v-else style="font-weight: bold;" class="typo__label" for="ajax">{{$t("message.selectBkp")}}</label>
    <multiselect @input="inputChange($event)" @select="selectedContact($event)" v-model="selectedContacts" id="ajax" label="name" track-by="id" :placeholder="$t('message.typeToSearch')"
                 open-direction="bottom" :options="filteredContacts" :multiple="true" :searchable="true" :loading="isLoading" :custom-label="nameWithDescription"
                 :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="300"
                 :limit="5" :limit-text="limitText" :max-height="600" :show-no-results="false" :hide-selected="true"
                 @search-change="asyncFind">
      <template slot="tag" slot-scope="{ option, remove }"><span style="padding-right: 7px;" class="custom__tag"><span>{{ option.name }}</span> - <span>{{ option.description }}</span><span
        class="custom__remove" style="cursor: pointer" @click="remove(option); removedElement(option);">❌</span></span></template>
      <template slot="clear" slot-scope="props">
        <div class="multiselect__clear" v-if="selectedContacts.length"
             @mousedown.prevent.stop="clearAll(props.search)"></div>
      </template>
      <span slot="noResult">{{$t("message.noResults")}}</span>
    </multiselect>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';

  export default {
    components: {
      Multiselect
    },
    data() {
      return {
        selectedContacts: [],
        filteredContacts: [],
        localContacts: [],
        isLoading: false
      }
    },
    props: ['contacts', 'contactsSelected'],
    created(){
      console.log(this.contacts)
      this.localContacts = this.contacts;
      this.selectedContacts = this.contactsSelected;
      this.filteredContacts = this.localContacts;
    },
    methods: {
      limitText(count) {
        return `and ${count} other contacts`
      },
      nameWithDescription({name, description}){
         return `${name} - ${description}`
      },
      asyncFind(query) {
        this.isLoading = true;
        this.filteredContacts = this.contactsFilter(query);
        this.isLoading = false
      },
      clearAll() {
        this.selectedContacts = []
      },
      selectedContact(event){
        this.$emit('selectedJob', event);
      },
      contactsFilter(data){
        return this.contacts.filter((el) => {
            let name = el.name.toLowerCase();

            return name.includes(data.toLowerCase());
        });
      },
      removedElement(option){
        this.$emit('removedJob', option);
      },
      inputChange(event){
        this.selectedContacts = [...new Set(event)];
      }
    }
  }

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
  .multiselect__content{
    min-height: 100px;
  }
</style>
